export default "__VITE_ASSET__DFS6AW0k__"